/*
<summary>
   This higher-order component is all about wrapping a component with Return Tool popup visibility state and its toggle handler.
   Developer: Aashish Singh, Created Date: 20-Aug-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { useState } from 'react';

const ReturnToolPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showReturnToolPopup, setShowReturnToolPopup] = useState<boolean>(false);

    const returnToggleHandler = () => {
      setShowReturnToolPopup(!showReturnToolPopup);
    };

    return (
      <Component
        showReturnToolPopup={showReturnToolPopup}
        returnToggleHandler={returnToggleHandler}
        {...props}
      />
    );
  };

export default ReturnToolPopupHOC;
